// ============== КНОПКА "Next to Payment" ======================

import { gtag_report_conversion_car_next_button } from '../../../gtag-conversion';
import { notify } from '../../toastify/toastify';
import { orderData } from '../orderData';
import { renderInfoOrder } from '../step3/infoOrder';

// =====================================
// Селектори
// =====================================
const refs = {
  btnToPayment: document.querySelector('[data-to-payment]'),

  sectionCars: document.querySelector('.content-box'),
  sectionPayment: document.querySelector('.payment'),
};

const { btnToPayment, sectionCars, sectionPayment } = refs;

// =====================================
// Слухач кнопки "Next to Payment"
// =====================================
function handlerClickBtnToPayment() {
  if (!Number(orderData.totalOrderPrice) || orderData.totalOrderPrice === 0) {
    notify('select_car', 'error');
    return;
  }

  renderInfoOrder();

  if (sectionCars) sectionCars.style.display = 'none';
  if (sectionPayment) sectionPayment.style.display = 'flex';

  sectionPayment?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
  gtag_report_conversion_car_next_button();
}
if (btnToPayment && sectionCars && sectionPayment) {
  if (!btnToPayment.dataset.listenerAttached) {
    btnToPayment.addEventListener('click', handlerClickBtnToPayment);
    btnToPayment.dataset.listenerAttached = 'true';
  }
}
